import "./Modal.scss";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";
import ReactDom from "react-dom";
import { MODAL_CONTENT } from "constants/constants";
import {
  ModalDetachmentText,
  valueStyleDetachment,
  sentenceStyleDetachment,
} from "utils/modalsHelper";

const DetachmentMissionModal = ({
  open,
  onClose,
  onValidate,
  icon,
  title,
  data,
  onCloseModal,
}) => {
  const { cslt_str, manager } = data;

  const missionBody = (
    <div className="mission-modal-body">
      <div className="mission-body-top" style={sentenceStyleDetachment}>
        <ModalDetachmentText
          id="the_consultant/str"
          defaultMessage="Le consultant/sous-traitant"
          value={cslt_str}
          valueStyle={valueStyleDetachment}
        />
        <ModalDetachmentText
          id="you_just_selected_currently_has_for_manager"
          defaultMessage="que vous venez de sélectioner a actuellement pour responsable"
          value={manager}
          valueStyle={valueStyleDetachment}
          dot={true}
        />
      </div>
      <div className="mission-body-bottom" style={sentenceStyleDetachment}>
        <ModalDetachmentText
          id="by_the_end_of_the_mission"
          defaultMessage="À la fin de la mission,"
          value={cslt_str}
          valueStyle={valueStyleDetachment}
        />
        <ModalDetachmentText
          id="must_he"
          defaultMessage="doit-il"
          value={null}
          valueStyle={valueStyleDetachment}
        />
      </div>
    </div>
  );

  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="modal-style">
        <ModalHeader
          onClose={onCloseModal}
          title={title}
          icon={icon}
          modalType={MODAL_CONTENT.MANAGE_MISSION_DETACHMENT}
        />
        <div className="modal_body">
          {missionBody}
          <br /> <br />
          <ModalFooter
            onClose={onClose}
            onValidate={onValidate}
            modalType={MODAL_CONTENT.MANAGE_MISSION_DETACHMENT}
            cancelButton={"go_back_to_his_former_manager"}
            validButton={"stay_in_my_team"}
          />
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default DetachmentMissionModal;
